import Script from "next/script"

type EmbedTweetProps = React.HTMLAttributes<HTMLDivElement> & {
  html: string
}

// TODO: remove all this and replace maybe with react-tweet. Requires NextJs v.13
export const EmbedTweet = ({ html, ...props }: EmbedTweetProps) => {
  return (
    <>
      <Script src="https://platform.twitter.com/widgets.js" />
      <div dangerouslySetInnerHTML={{ __html: html }} {...props} />
    </>
  )
}

EmbedTweet.displayName = "EmbedTweet"
